import { render, staticRenderFns } from "./TaskInfoWithNoSourceDb.vue?vue&type=template&id=54faa7d8&scoped=true"
import script from "./TaskInfoWithNoSourceDb.vue?vue&type=script&lang=js"
export * from "./TaskInfoWithNoSourceDb.vue?vue&type=script&lang=js"
import style0 from "./TaskInfoWithNoSourceDb.vue?vue&type=style&index=0&id=54faa7d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54faa7d8",
  null
  
)

export default component.exports